import React from 'react'
import { BottleneckMessage, bottleneckMessageHasRelatedCalls } from '../domain/BottleneckMessage'
import { FunctionCall } from '../helper/FunctionCall'
import Link from '../helper/link'
import Milliseconds from '../helper/milliseconds'

type Props = {
    message?: BottleneckMessage
    routes?: {
        callgraphRoute: string
    }
}

export const BottleneckRelatedCalls: React.FunctionComponent<Props> = ({ routes, message }) => {
    if (!routes || !message?.args) {
        return null
    }

    if (!bottleneckMessageHasRelatedCalls(message.args)) {
        return null
    }

    if (Object.keys(message.args.relatedCalls).length === 0) {
        return null
    }

    return (
        <>
            <h4 className="tw-font-size-16 tw-mt-24">Related Calls</h4>
            <table className="table table-striped table-bordered table-condensed">
                <tbody>
                    {Object.entries(message.args.relatedCalls)
                        .sort((a, b) => b[1] - a[1])
                        .map(([call, totalTime]) => (
                            <tr key={call}>
                                <td>
                                    <Link route={routes.callgraphRoute} params={{ fn: call }}>
                                        <div style={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between' }}>
                                            <div>
                                                <FunctionCall call={call} />
                                            </div>
                                            <div>
                                                <Milliseconds value={totalTime} />
                                            </div>
                                        </div>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                </tbody>
            </table>
        </>
    )
}
